export default "__VITE_ASSET__Dcs6tFGC__"